import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {GetDashboardReportDetails, SetQueryParams} from '../store/action/dashboard-actions';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {of, Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {IDashboardState} from '../store/reducer/dashboard-reducer';
import {getQueryParameters} from '../store/selector/dashboard-selector';
import {getCurrentProject, ProjectState} from '../../projects/store/reducers/projects.reducer';
import {ProjectModel} from '../../projects/models/projects.models';
import {DashboardHitmapComponent} from '../dashboard-hitmap/dashboard-hitmap.component';
import {QueryProvider} from '@shared/queries/query-provider';
import {DashboardResetSelectedItemCommand, RefresheSelectedItemCommand} from '@shared/commands/dashboard.command';

@Component({
    standalone: false,
    selector: 'particle-dashboard-content',
  templateUrl: './dashboard-content.component.html',
  styleUrls: ['./dashboard-content.component.scss']
})
export class DashboardContentComponent implements OnInit, OnDestroy{
  filterKey: string;
  unsubscribe$ = new Subject<void>();
  fromDateString: string;
  toDateString: string;
  childUrlChange: boolean = false;
  currentProjectId: string;
  intervalTimer: any;
  loadingPercentage: any = {};
  filterQueryParams: any;
  dashboardHitmapQueryKey = 'dashboardHeatmapVisualizer';
  @ViewChild(DashboardHitmapComponent, {static: true}) dashboardHitmap: DashboardHitmapComponent;
  private refreashQueryKey: string = 'refreshVisualizer';
  private refreshReportType: string = 'DashboardHeatmapReport';

  constructor(private activatedRoute: ActivatedRoute, private dashboardStore: Store<IDashboardState>, private router: Router, private  projectStore: Store<ProjectState>) {
    this.filterKey = 'dashboardResultFilter';
  }

  ngOnInit() {
    this.projectStore.pipe(select(getCurrentProject), takeUntil(this.unsubscribe$)).subscribe((project: ProjectModel) => {
      if (project) {
        this.currentProjectId = project.ProjectId;
      }
    });
    this.dashboardStore.pipe(select(getQueryParameters), takeUntil(this.unsubscribe$)).subscribe((state: Params) => {
      if (state && state.fromDate && state.toDate) {
        if(state.fromDate !== this.fromDateString || state.toDate !== this.toDateString){
          this.filterQueryParams = state;
        }
      }
    });
    //this.dashboardHitmapQueryKey = QueryProvider.getPostCommandFullUrl(this.dashboardHitmapQueryKey);
    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(queryParams => {
      if (queryParams.fromDate && queryParams.toDate) {
        if (queryParams.fromDate !== this.fromDateString || queryParams.toDate !== this.toDateString) {
          this.fromDateString = queryParams.fromDate;
          this.toDateString = queryParams.toDate;
          this.dashboardStore.dispatch(new SetQueryParams(queryParams));
        }
      }
    });
  }

  refreashReportService() {
    if (!this.dashboardHitmap) {
      console.log('dashboardHitmap component not initiated');
    }
    this.dashboardHitmap.dataLoaded = false;
    this.dashboardHitmap.failureResponse = false;
    this.dashboardHitmap.failureResponse$ = of(false);
    this.dashboardHitmap.loadingAnimation();

    const endPointUrl = QueryProvider.getPostCommandFullUrl(this.refreashQueryKey);
    const payload = {
      projectId: this.currentProjectId, fromDate: this.fromDateString, toDate: this.toDateString, home : false
    }
    const command = new RefresheSelectedItemCommand(endPointUrl, payload, this.refreshReportType);
    this.dashboardStore.dispatch(new GetDashboardReportDetails(command));
    /*if(!this.dashboardHitmap){
     console.log('dashboardHitmap component not initiated');
     }
     this.dashboardHitmap.dataLoaded = false;
     const payload ={
     reportType: 'DashboardHeatmapReport',
     payload: {
     projectId: this.currentProjectId,
     startDate: this.fromDateString,
     endDate:  this.toDateString
     }
     };
     let refreshedData;
     this.dashboardHitmap.loadingAnimation();
     this.dashboardService.refreashReport(payload).subscribe((data: any)=>{
     if(data) {
     this.dashboardHitmap.dataLoaded = true;
     this.dashboardHitmap.failureResponse = false;
     this.dashboardHitmap.failureResponse$ = of(false);
     const report = data.Payload.replace('/','');
     refreshedData = JSON.parse(report);
     this.dashboardHitmap.displayReport(refreshedData.ReportId, refreshedData.GroupId, refreshedData.EmbedToken);
     }
     },
     error=>{
     this.fuseSplashScreenService.hide();
     this.dashboardHitmap.failureResponse = true;
     this.dashboardHitmap.failureResponse$ = of(true);
     });*/
  }
  resetReport() {
    if (!this.dashboardHitmap) {
      console.log('dashboardHitmap component not initiated');
    }
    this.dashboardHitmap.dataLoaded = false;
    this.dashboardHitmap.failureResponse = false;
    this.dashboardHitmap.failureResponse$ = of(false);
    this.dashboardHitmap.loadingAnimation();
    const endpointUrl = QueryProvider.getPostCommandFullUrl(this.dashboardHitmapQueryKey);
    let command = new DashboardResetSelectedItemCommand(endpointUrl, true);
    command.fromDate = this.fromDateString;
    command.toDate = this.toDateString;
    command.projectId = this.currentProjectId;
    this.dashboardStore.dispatch(new GetDashboardReportDetails(command));
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
